<template>

       <div class="container">
                <div class="page-header">
                    <div class="page-title">

                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                 <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li>
                                  <router-link :title="'الطلاب'" :to="{name: 'my-students'}">بيانات طلابى المقبولين</router-link>
                                </li>
                                 <li class="active">
                                  <router-link :title="'تعديل'" :to="{name: 'my-students.edit', params: {id: $route.params.id}}">تعديل</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

            <div class="row">

                    <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12  layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                           <i class="flaticon-computer-4"></i>
                                          بيانات الطالب</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">
                              <ul class="nav nav-tabs" id="myTab" role="tablist">
                                <li class="nav-item">
                                  <a class="nav-link active" id="personal-tab" data-toggle="tab" href="#personal" role="tab" aria-controls="personal" aria-selected="true"><i class="fa-regular fa-user text-primary"></i> البيانات الشخصية</a>
                                </li>
                                 <li class="nav-item">
                                  <a class="nav-link" id="ident-tab" data-toggle="tab" href="#ident" role="tab" aria-controls="ident" aria-selected="false"><i class="fa-regular fa-address-book text-primary"></i> معلومات الهوية</a>
                                </li>
                                <li class="nav-item">
                                  <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false"><i class="fa-regular fa-address-card text-primary"></i> معلومات التواصل</a>
                                </li>

                                <li class="nav-item">
                                  <a class="nav-link" id="work-tab" data-toggle="tab" href="#work" role="tab" aria-controls="work" aria-selected="false"><i class="fa-regular fa-note-sticky text-primary"></i> معلومات العمل</a>
                                </li>
                                <li class="nav-item">
                                  <a class="nav-link" id="exp-tab" data-toggle="tab" href="#exp" role="tab" aria-controls="exp" aria-selected="false"><i class="fa-regular fa-note-sticky text-primary"></i> معلومات ولى الامر</a>
                                </li>
                                <li class="nav-item">
                                  <a class="nav-link" id="imgs-tab" data-toggle="tab" href="#imgs" role="tab" aria-controls="imgs" aria-selected="false"><i class="fa-regular fa-note-sticky text-primary"></i> صورة الهوية </a>
                                </li>
                              </ul>
                              <form @submit.prevent="update()">
                                <div class="tab-content" id="myTabContent">
                                  <div class="tab-pane fade show active" id="personal" role="tabpanel" aria-labelledby="personal-tab">
                                    <div class="row mt-4">
                                      <div class="col-md-6">
                                              <label for="exampleFormControlInput12">الاسم</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                            <input type="text" class="form-control" id="exampleFormControlInput12" v-model="data.form.name" placeholder="الاسم كامل">
                                            <div class="invalid-feedback" :style="getErrors['name'] ? 'display: block' : 'display: none;'"  v-if="getErrors['name']">
                                                  {{ getErrors['name'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                       <div class="col-md-6">
                                        <label for="exampleFormControlInput12">مكان الميلاد</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-location"></i></span>
                                      </div>
                                            <input type="text" class="form-control" v-model="data.form.birth_place" placeholder="مكان الميلاد">
                                            <div class="invalid-feedback" :style="getErrors['birth_place'] ? 'display: block' : 'display: none;'"  v-if="getErrors['birth_place']">
                                                  {{ getErrors['birth_place'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-6">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">الحالة الاجتماعية</label>
                                            <div class="row">
                                              <div class="col-md-3"><input type="radio" v-model="data.form.marital_status" value="طالب"> طالب</div>
                                              <div class="col-md-3"><input type="radio" v-model="data.form.marital_status" value="أعزب"> أعزب</div>
                                              <div class="col-md-3"><input type="radio" v-model="data.form.marital_status" value="متزوج"> متزوج</div>
                                              <div class="col-md-3"><input type="radio" v-model="data.form.marital_status" value="أرمل"> أرمل</div>
                                            </div>
                                            <div class="invalid-feedback" :style="getErrors['marital_status'] ? 'display: block' : 'display: none;'"  v-if="getErrors['marital_status']">
                                                  {{ getErrors['marital_status'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                    </div>

                                    </div>
                                  <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                                     <div class="row mt-4">
                                      <div class="col-md-6">

                                        <label for="exampleFormControlInput12">عنوان المنزل</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-location"></i></span>
                                      </div>
                                            <input type="text" class="form-control" v-model="data.form.address" placeholder="اكتب العنوان">
                                            <div class="invalid-feedback" :style="getErrors['address'] ? 'display: block' : 'display: none;'"  v-if="getErrors['address']">
                                                  {{ getErrors['address'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                     <div class="col-md-6">

                                    <label for="exampleFormControlInput12">رقم الهاتف 1</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-telephone"></i></span>
                                      </div>
                                            <input type="text" class="form-control" v-model="data.form.phone1" placeholder="رقم الهاتف 1">
                                            <div class="invalid-feedback" :style="getErrors['phone1'] ? 'display: block' : 'display: none;'"  v-if="getErrors['phone1']">
                                                  {{ getErrors['phone1'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                       <div class="col-md-6">

                                     <label for="exampleFormControlInput12">رقم الهاتف 2</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-telephone"></i></span>
                                      </div>
                                            <input type="text" class="form-control" v-model="data.form.phone2" placeholder="رقم الهاتف 2">
                                            <div class="invalid-feedback" :style="getErrors['phone2'] ? 'display: block' : 'display: none;'"  v-if="getErrors['phone2']">
                                                  {{ getErrors['phone2'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                     <div class="col-md-6">
                                      <label for="exampleFormControlInput12">رقم الجوال</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-telephone"></i></span>
                                      </div>
                                            <input type="text" class="form-control" v-model="data.form.mobile" placeholder="رقم الجوال">
                                            <div class="invalid-feedback" :style="getErrors['mobile'] ? 'display: block' : 'display: none;'"  v-if="getErrors['mobile']">
                                                  {{ getErrors['mobile'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                       <div class="col-md-6">
                                   <label for="exampleFormControlInput12">رقم واتس آب</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-telephone"></i></span>
                                      </div>

                                            <input type="text" class="form-control" v-model="data.form.whatsapp" placeholder="رقم واتس آب">
                                            <div class="invalid-feedback" :style="getErrors['whatsapp'] ? 'display: block' : 'display: none;'"  v-if="getErrors['whatsapp']">
                                                  {{ getErrors['whatsapp'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-6">
                                         <label for="exampleFormControlInput12"> البريد الإلكتروني</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-email"></i></span>
                                      </div>

                                            <input type="email" class="form-control" v-model="data.form.email" placeholder="البريد الإلكتروني">
                                            <div class="invalid-feedback" :style="getErrors['email'] ? 'display: block' : 'display: none;'"  v-if="getErrors['email']">
                                                  {{ getErrors['email'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                    </div>

                                  </div>
                                  <div class="tab-pane fade" id="ident" role="tabpanel" aria-labelledby="ident-tab">
                                    <div class="row mt-4">
                                       <div class="col-md-6">
                                         <label for="exampleFormControlInput12">رقم الهوية</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                            <input type="text" class="form-control" v-model="data.form.id_number" placeholder="رقم الهوية">
                                            <div class="invalid-feedback" :style="getErrors['id_number'] ? 'display: block' : 'display: none;'"  v-if="getErrors['id_number']">
                                                  {{ getErrors['id_number'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                                        <div class="col-md-6">
                              <label for="exampleFormControlInput12">مصدرها</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-location"></i></span>
                                      </div>

                                            <input type="text" class="form-control" v-model="data.form.id_place" placeholder="مصدر الهوية">
                                            <div class="invalid-feedback" :style="getErrors['id_place'] ? 'display: block' : 'display: none;'"  v-if="getErrors['id_place']">
                                                  {{ getErrors['id_place'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                         <div class="col-md-6">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">تاريخها</label>
                                            <date-picker v-model="data.form.id_date"  :calendar="'hijri'"></date-picker>
                                            <div class="invalid-feedback" :style="getErrors['id_date'] ? 'display: block' : 'display: none;'"  v-if="getErrors['id_date']">
                                                  {{ getErrors['id_date'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-6">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">تاريخ الانتهاء</label>
                                            <date-picker v-model="data.form.id_expire_date" :editable="true" :calendar="'hijri'"></date-picker>
                                            <div class="invalid-feedback" :style="getErrors['id_expire_date'] ? 'display: block' : 'display: none;'"  v-if="getErrors['id_expire_date']">
                                                  {{ getErrors['id_expire_date'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                       <div class="col-md-12">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12"> نوع الهوية</label>
                                            <div class="row">
                                              <div class="col-md-3">
                                                <input type="radio" v-model="data.form.id_type" value="رقم الاقامة"> <label for="">رقم الاقامة</label>
                                              </div>
                                              <div class="col-md-3">
                                                <input type="radio" v-model="data.form.id_type" value="رقم البرنت للمرفقين" > <label for="">رقم البرنت للمرفقين</label>
                                              </div>
                                              <div class="col-md-3">
                                                <input type="radio" v-model="data.form.id_type" value="بطاقة أحوال"> <label for="">بطاقة أحوال</label>
                                              </div>
                                              <div class="col-md-3">
                                                <input type="radio" v-model="data.form.id_type" value="كرت عائلة"> <label for="">كرت عائلة</label>
                                              </div>
                                            </div>
                                            <div class="invalid-feedback" :style="getErrors['id_type'] ? 'display: block' : 'display: none;'"  v-if="getErrors['id_type']">
                                                  {{ getErrors['id_type'][0] }}
                                            </div>
                                        </div>
                                      </div>



                                    </div>
                                  </div>
                                  <div class="tab-pane fade" id="work" role="tabpanel" aria-labelledby="work-tab">
                                    <div class="row mt-4">
                                            <div class="col-md-4">
                                         <label for="exampleFormControlInput12">العمل </label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                            <input type="text" class="form-control" v-model="data.form.work" placeholder="العمل الرسمى">
                                            <div class="invalid-feedback" :style="getErrors['work'] ? 'display: block' : 'display: none;'"  v-if="getErrors['work']">
                                                  {{ getErrors['work'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                                                         <div class="col-md-4">
                                        <label for="exampleFormControlInput12">العنوان</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-location"></i></span>
                                      </div>
                                            <input type="text" class="form-control" v-model="data.form.work_address" placeholder="اكتب عنوان العمل">
                                            <div class="invalid-feedback" :style="getErrors['work_address'] ? 'display: block' : 'display: none;'"  v-if="getErrors['work_address']">
                                                  {{ getErrors['work_address'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                                                                    <div class="col-md-4">
                                      <label for="exampleFormControlInput12">الهاتف</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-telephone"></i></span>
                                      </div>

                                            <input type="text" class="form-control" v-model="data.form.work_phone" placeholder="الهاتف">
                                            <div class="invalid-feedback" :style="getErrors['work_phone'] ? 'display: block' : 'display: none;'"  v-if="getErrors['work_phone']">
                                                  {{ getErrors['work_phone'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                  <div class="tab-pane fade" id="exp" role="tabpanel" aria-labelledby="exp-tab">
                                    <div class="row mt-4">
                             <div class="col-md-6">
                                     <label for="exampleFormControlInput12">اسم ولى الامر </label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>


                                            <input type="text" class="form-control" v-model="data.form.parent_name" placeholder="اسم ولى الامر">
                                            <div class="invalid-feedback" :style="getErrors['parent_name'] ? 'display: block' : 'display: none;'"  v-if="getErrors['parent_name']">
                                                  {{ getErrors['parent_name'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                                       <div class="col-md-6">
                                <label for="exampleFormControlInput12">عمل ولى الامر </label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>



                                            <input type="text" class="form-control" v-model="data.form.parent_work" placeholder="عمل ولى الامر">
                                            <div class="invalid-feedback" :style="getErrors['parent_work'] ? 'display: block' : 'display: none;'"  v-if="getErrors['parent_work']">
                                                  {{ getErrors['parent_work'][0] }}
                                            </div>
                                        </div>
                                      </div>
                             <div class="col-md-6">
                                      <label for="exampleFormControlInput12">هاتف عمله </label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-telephone"></i></span>
                                      </div>



                                            <input type="text" class="form-control" v-model="data.form.parent_work_phone" placeholder="هاتف عمله">
                                            <div class="invalid-feedback" :style="getErrors['parent_work_phone'] ? 'display: block' : 'display: none;'"  v-if="getErrors['parent_work_phone']">
                                                  {{ getErrors['parent_work_phone'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                                          <div class="col-md-6">
                                     <label for="exampleFormControlInput12">جواله </label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-telephone"></i></span>
                                      </div>



                                            <input type="text" class="form-control" v-model="data.form.parent_mobile" placeholder="جواله">
                                            <div class="invalid-feedback" :style="getErrors['parent_mobile'] ? 'display: block' : 'display: none;'"  v-if="getErrors['parent_mobile']">
                                                  {{ getErrors['parent_mobile'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                                            <div class="col-md-12">
                      <label for="exampleFormControlInput12">صلة القرابة </label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>



                                            <input type="text" class="form-control" v-model="data.form.parent_relation" placeholder="صلة القرابة">
                                            <div class="invalid-feedback" :style="getErrors['parent_relation'] ? 'display: block' : 'display: none;'"  v-if="getErrors['parent_relation']">
                                                  {{ getErrors['parent_relation'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>

                                  <div class="tab-pane fade" id="imgs" role="tabpanel" aria-labelledby="imgs-tab">
                                    <div class="row mt-4">

                                      <div class="col-md-6">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12"> صورة الهوية </label>
                                           <input type="file" ref="file" class="form-control" accept="image/*"  @change="uploadImage">
                                           <img :src="data.form.image_id_path" width="100%" height="350px" alt="">
                                            <div class="invalid-feedback" :style="getErrors['image_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['image_id']">
                                                  {{ getErrors['image_id'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-6">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12"> صورة شخصية </label>
                                           <input type="file" ref="file1" class="form-control" accept="image/*"  @change="uploadImageProfile">
                                           <img :src="data.form.image_path" width="100%" height="350px" alt="">
                                            <div class="invalid-feedback" :style="getErrors['image'] ? 'display: block' : 'display: none;'"  v-if="getErrors['image']">
                                                  {{ getErrors['image'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                </div>

                                    <button type="submit" class="save-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>حفظ</span></button>
                                    <button type="button" @click.prevent="resetForm" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>تفريغ</span></button>
                                    <router-link class="back-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p" :to="{name: 'students'}">
                                      <span>رجوع</span>
                                    </router-link>
                              </form>

                            </div>
                        </div>
                    </div>

                </div>

            </div>
</template>
<script>
import router from '@/router'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import VueDatetimeJs from 'vue-datetime-js'

export default {
  components: {
    datePicker: VueDatetimeJs,
    Treeselect

  },
  data() {
    return {
      stages: [],
       stage: '',
       groups: [],
       group: '',
       lessons: [],
       lesson: '',
       supervisors: [],
       supervisor: '',
       teachers: [],
       teacher: '',
      data: {
        checker: false,
        form:{
            name: '',
            birth_date: '',
            birth_place: '',
            student_status: '',
            marital_status: '',
            lesson_id: '',
            group_id: '',
            teacher_id: '',
            stage_id: '',
            supervisor_id: '',
            interview_id: '',
            address: '',
            register_date: '',
            whatsapp: '',
            mobile: '',
            phone1: '',
            phone2: '',
            email: '',
            id_number: '',
            id_place: '',
            id_type: '',
            id_date: '',
            id_expire_date: '',
            work: '',
            work_address: '',
            work_phone: '',
            parent_name: '',
            parent_work: '',
            parent_work_phone: '',
            parent_mobile: '',
            parent_relation: '',
            image_id: '',
            image: '',
        },
        roles: {
        },
        options: [],
        isRequested: false,
        errors: {},
        paginated: {}
      }
    };
  },
  created(){
      this.getRequirements();
  },
  methods: {
    resetForm(){
          this.data.form = {
             name: '',
            birth_date: '',
            birth_place: '',
            marital_status: '',
            address: '',
            register_date: '',
            whatsapp: '',
            mobile: '',
            phone1: '',
            phone2: '',
            email: '',
            id_number: '',
            id_place: '',
            id_type: '',
            id_date: '',
            id_expire_date: '',
            work: '',
            work_address: '',
            work_phone: '',
            parent_name: '',
            parent_work: '',
            parent_work_phone: '',
            parent_mobile: '',
            parent_relation: '',
            image_id: '',
            image: '',
        };


    },
      getInfo(){
        this.$baseApi.get('/my-students/' + this.$route.params.id + '/edit').then((response)=>{
            if(response.data.code == 200 && response.data.data != null){
                this.data.form = response.data.data.student;
                this.data.form.image = '';
                this.data.form.image_id = '';

            }else if(response.data.code == 404){
                router.push('/students');
            }else{
                alert(response.data.data.error);
                router.push('/students');
            }
        });
      },

     uploadImage(e){
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e =>{
                  this.data.form.image_id = e.target.result;
                };
      },

      uploadImageProfile(e){
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e =>{
                  this.data.form.image = e.target.result;
                };
      },
      update(){
          this.data.isRequested = true;
        this.$baseApi.patch('/my-students/' + this.$route.params.id, this.data.form).then((response)=>{
            if(response.data.code === 200){
              localStorage.setItem('flash_message', 'تمت عملية التعديل');
                router.push('/my-students');
            }
        }).catch((error) => {
          this.data.errors = JSON.parse(JSON.stringify(error.response.data.errors));
          this.data.isRequested = false
        })
      },
      getRequirements(){
        this.getInfo();
      },
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    },
    getErrors() {
      return JSON.parse(JSON.stringify(this.data.errors))
    }
  }
};
</script>
<style>
</style>
